import styled from 'styled-components';
import tw from 'twin.macro';

import { Footer } from './Footer';
import { Slider } from './Slider';

export const InfoGraphics = () => {
  return (
    <Container>
      <SliderContainer>
        <Slider />
      </SliderContainer>
      <Footer />
    </Container>
  );
};

const Container = styled.div`
  ${tw`relative h-full w-full flex flex-col justify-center bg-gray-200 items-center`}
`;

const SliderContainer = styled.div`
  ${tw`grow flex w-full flex-col justify-center items-center`}
`;
